import { createAsyncThunk, rejectWithValue } from "@reduxjs/toolkit";
import { attendanceStatusListApi,createStatusApi,updateStatusApi,deleteStatusApi,getAttendanceStatusApi } from "./StatusApi";
import { showApiErrorToast, showApiSuccessToast } from "../../utils/toastErrorHandler";
import { toast } from "react-toastify";
const handleError = (err, rejectWithValue) => {
  if (err.response?.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  }

  const data = err.response?.data;

  let errorMessage =
    data?.errors?.[0]?.msg ||
    data?.message ||
    data?.error ||
    err.message ||
    "Something went wrong";

  showApiErrorToast(errorMessage);

  return rejectWithValue(errorMessage);
};

export const attendanceStatusList = createAsyncThunk(
  "status/status_list",
  async (payload, { rejectWithValue }) => {
      console.log("Payload in Action:", payload);
    try {
      const response = await attendanceStatusListApi(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

export const createStatus = createAsyncThunk(
  "status/create",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createStatusApi(payload);
      showApiSuccessToast(response.data.message)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getAttendanceStatusById = createAsyncThunk(
  "status/getStatusById",
 async(payload, { rejectWithValue}) => {
  try{
    const response = await getAttendanceStatusApi(payload);
    return response.data;
  }catch (err) {
    return handleError(err, rejectWithValue)
  }

 }
)

export const updateStatus = createAsyncThunk(
  "status/status_update",
  async (payload, { rejectWithValue }) => {
    try{
      const response = await updateStatusApi(payload);
            showApiSuccessToast(response.data.message)

      return response.data;
    }
    catch(error) {
      return rejectWithValue(error.response?.data);
    }
  }
)
export const deleteStatus = createAsyncThunk(
  "status/status_delete",
  async (payload, { rejectWithValue }) => {
    try{
      const response = await deleteStatusApi(payload);
       console.log(response.data);
      showApiSuccessToast(response.data.message)
      return response.data;
    }
    catch(error) {
      return rejectWithValue(error.response?.data)
    }
  }
)
